<template>
    <header class="gh-header mcd-header">
        <nav class="gh-header__nav container header-container" ref="mobileStickyNavigator">
            <router-link to="/" class="gh-header__logo">
                <img :src="eventLogo" :alt="logoAlt">
            </router-link>

            <ul class="gh-list gh-header__menu" v-if="showTagline">
                <li class="gh-list__item tagline">
                    Hosted by Mental Health Academy
                </li>
            </ul>
        </nav>
    </header> <!-- End Header -->
</template>

<script>
    import documentMixin from '../mixins/document';

    export default {
        mixins: [documentMixin],

        computed: {
            eventLogo() {
                return {
                    mcd: '/images/app/MHA-Logo-2017[P].svg',
                    summit: '/images/app/MHA-Logo-2017[P].svg'
                }[this.eventType] || '/images/app/MHA-Logo-2017[P].svg';
            },

            logoAlt() {
                return {
                    mcd: 'Mental Health Academy Masterclass Day Logo',
                    summit: 'Mental Health Academy Super Summit Logo'
                }[this.eventType] || 'Mental Health Academy Logo';
            },

            showTagline() {
                return true;
            }
        }
    }
</script>
